import api, { adminApi } from "./api";

export const getPublicSystemSettingsApi = async () => {
    const res = await api.get("/api/v1/admin/system-settings/public", { skipAuth: true });
    return res.data;
};


class AdminSettingsService {
    async getPaymentSettings() {
        return await adminApi.get("/api/v1/admin/payment-settings");
    }

    async updatePaymentSettings(data) {
        return await adminApi.put("/api/v1/admin/payment-settings", data);
    }

    async uploadQRCode(file) {
        const formData = new FormData();
        formData.append("qrImage", file);
        return await adminApi.post("/api/v1/admin/payment-settings/qr-image", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    async deleteQRCode() {
        return await adminApi.delete("/api/v1/admin/payment-settings/qr-image");
    }

    async learnReceiverFromSlip(file) {
        const formData = new FormData();
        formData.append("slip", file);
        return await adminApi.post("/api/v1/admin/payment-settings/learn-receiver", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    async getSystemSettings() {
        return await adminApi.get("/api/v1/admin/system-settings");
    }

    async updateSystemSettings(data) {
        return await adminApi.put("/api/v1/admin/system-settings", data);
    }
}

export default new AdminSettingsService();
